export enum LATE_GOAL_CONFIG {
  htStart = 30,
  htStop = 45,
  ftStart = 75,
  ftStop = 90,
}
